export default function ($http) {
    return function () {
        return $http({
            url: 'api/tags',
            method: 'GET'
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/services/getTagList.js